import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { HttpClientModule} from '@angular/common/http'

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SurveyComponent } from './survey/survey.component';
import { QuestionComponent } from './question/question.component';

import {QuestionsService} from './services/questionsService';
import {ResponseChangedService} from './services/responseChangedService';
import {SurveyService} from './services/surveyService'
import {SurveyGuardService} from './services/surveyGuardService'
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { IntroComponent } from './intro/intro.component';
import { OutroComponent } from './outro/outro.component';
import { ErrorComponent } from './error/error.component';
import { ApplicationStorage } from './services/applicationStorage';
import { AppFooterComponent } from './app-footer/app-footer.component';

@NgModule({
  declarations: [
    AppComponent,
    SurveyComponent,
    QuestionComponent,
    IntroComponent,
    OutroComponent,
    ErrorComponent,
    AppFooterComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    NgbModule,
    FormsModule,
    HttpClientModule
  ],
  providers: [QuestionsService, ResponseChangedService, SurveyService, SurveyGuardService, ApplicationStorage],
  bootstrap: [AppComponent]
})
export class AppModule { }
